import TemplateView from '../../../../../TemplateView'
import messageResource from '../../../../../messageResource'
import DocumentsLinksList from './DocumentsLinksList'
import AddressChangesNote from './AddressChangesNote'
import {purchaseStrategyType} from '../../../constants'

export default class TransferCheckContent extends TemplateView {
    constructor() {
        super()

        this.state = {
            purchaseStrategyType: '',
            name: '',
            hostingZone: '',
            isHostingZoneChanged: false,
            context: '',
            isContextChanged: false,
            documentUrls: {
                serviceAgreementUrl: null,
                dataProcessingAgreementUrl: null,
                serviceAgreementExhibitUrl: null,
                invoiceUrl: null,
            },
            documentsBaseUrl: '',
        }

        this.onStatePropertyChanged('name', (name) => {
            this.$title.text(messageResource.getMessage('licenses.purchase.success.check_wire_transfer_purchase.title', [name]))
        })

        this.onAnyStatePropertyChanged(
            ['isHostingZoneChanged', 'hostingZone', 'context', 'isContextChanged'],
            () => this._addressWasChangedHandler()
        )

        this.onStatePropertyChanged('documentUrls', (documentUrls) => {
            this.documentsLinksList.setState({documentUrls})
        })

        this.onStatePropertyChanged('documentsBaseUrl', (documentsBaseUrl) => {
            this.documentsLinksList.setState({documentsBaseUrl})
        })

        this.onStatePropertyChanged('purchaseStrategyType', () => {
            const isAddUsersPurchase = this.state.purchaseStrategyType === purchaseStrategyType.ADD_USERS
            if (isAddUsersPurchase) {
                this.$effectTitle.text(messageResource.getMessage('licenses.purchase.success.check_wire_transfer_purchase.effect_date_title.add_users'))
            } else {
                this.$effectTitle.text(messageResource.getMessage('licenses.purchase.success.check_wire_transfer_purchase.effect_date_title'))
            }
            this.$supportNote.toggle(isAddUsersPurchase)
        })
    }

    templateHtml() {
        return '<div class="container">' +
               '    <div class="img"/>' +
               '    <div class="purchaseTitle"/>' +
               '    <div class="titleNote"><%=additionalPurchaseTitle%></div>' +
               '    <div class="documentsLinksList"/>' +
               '    <div class="effectTitle"/>' +
               '    <div class="supportNote"><%=supportNoteText%></div>' +
               '    <div class="addressChangesNote"/>' +
               '</div>'
    }

    messageKeys() {
        return {
            additionalPurchaseTitle: 'licenses.purchase.success.check_wire_transfer_purchase.additional_title',
            supportNoteText: 'licenses.purchase.success.check_wire_transfer_purchase.support_note',
        }
    }

    afterRender() {
        this.$title = this.find('.purchaseTitle')
        this.$effectTitle = this.find('.effectTitle')
        this.$supportNote = this.find('.supportNote')

        this.documentsLinksList = new DocumentsLinksList().init(this.find('.documentsLinksList'))
        this.documentsLinksList.setState({isProformaInvoice: true})

        this.addressChangesNote = new AddressChangesNote({noteTextKey: 'licenses.purchase.success.purchase_title_change_address_note.title'})
            .init(this.find('.addressChangesNote'))
    }

    _addressWasChangedHandler() {
        this.addressChangesNote.setState({
            hostingZone: this.state.hostingZone,
            isHostingZoneChanged: this.state.isHostingZoneChanged,
            context: this.state.context,
            isContextChanged: this.state.isContextChanged,
        })

        this.getEl().toggleClass('noAddressChanges', !(this.state.isContextChanged || this.state.isHostingZoneChanged))
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/successStep/TransferCheckContent.js